import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// Enum for param names
export enum ChatSearchParam {
  ShowSplash = 'showSplash',
  HideFooter = 'hideFooter',
  ViewMode = 'viewMode',
  PaymentCompleted = 'paymentCompleted',
  UserMessage = 'userMessage',
  FromWaitlist = 'fromWaitlist',
}

const isTruthyParam = (value: string | null): boolean => {
  if (value === null) {
    return false;
  }
  return value.toLowerCase() === 'true';
};

export const useChatSearchParams = () => {
  const [searchParams] = useSearchParams();

  const [shouldShowSplashForce, setShouldShowSplashForce] = useState(isTruthyParam(searchParams.get(ChatSearchParam.ShowSplash)));
  const [hideFooter, setHideFooter] = useState(isTruthyParam(searchParams.get(ChatSearchParam.HideFooter)));
  const [viewMode, setViewMode] = useState(isTruthyParam(searchParams.get(ChatSearchParam.ViewMode)));
  const [paymentCompleted, setPaymentCompleted] = useState(isTruthyParam(searchParams.get(ChatSearchParam.PaymentCompleted)));
  const [userMessage, setUserMessage] = useState<string | null>(searchParams.get(ChatSearchParam.UserMessage));
  const [fromWaitlist, setFromWaitlist] = useState(isTruthyParam(searchParams.get(ChatSearchParam.FromWaitlist)));

  const deleteSearchParam = (param: ChatSearchParam) => {
    const url = new URL(window.location.href);
    url.searchParams.delete(param);
    window.history.replaceState({}, document.title, url.pathname + url.search);

    switch (param) {
      case ChatSearchParam.ShowSplash:
        setShouldShowSplashForce(false);
        break;
      case ChatSearchParam.HideFooter:
        setHideFooter(false);
        break;
      case ChatSearchParam.ViewMode:
        setViewMode(false);
        break;
      case ChatSearchParam.PaymentCompleted:
        setPaymentCompleted(false);
        break;
      case ChatSearchParam.UserMessage:
        setUserMessage(null);
        break;
      case ChatSearchParam.FromWaitlist:
        setFromWaitlist(false);
        break;
      default:
        break;
    }
  };

  return { shouldShowSplashForce, hideFooter, viewMode, paymentCompleted, userMessage, fromWaitlist, deleteSearchParam };
};
